import * as React from 'react';

import DropButton from '~/common/controls/DropButton';
import Table from '~/common/components/Table';


export default (props) => {
  const { onOrganizationClick, ...rest } = props;

  const handleOrganizationClick = (e, org) => {
    e.preventDefault();
    onOrganizationClick(org);
  };

  const options = [
    {
      label: 'Delete',
      onClick: (e) => alert('Delete!'),
    }
  ];

  const columns = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Cell: (row) => {
        return (
          <DropButton
            onClick={(e) => handleOrganizationClick(e, row.original)}
            label="Edit"
            options={options}
          />
        );
      }
    },
  ];

  return (
    <Table
      columns={columns}
      {...rest}
    />
  );
};
